import React, {Component} from "react";
import {Grid, Input} from "semantic-ui-react";
import Repeater from "./repeater";
import {from} from "linq";
import PropTypes from "prop-types";

class FilterableRepeater extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchCriteria: "",
            currentPage: 1,
            pageSize: 10,
            filteredData: [],
            pagedData: []
        };

        this.filterResults();
    }

    get totalCount() {
        return this.state.filteredData.length;
    }

    get totalPages() {
        return Math.ceil(this.totalCount / this.state.pageSize);
    }

    get textFilterFields() {
        return this.props.textFilterFields ? this.props.textFilterFields : [];
    }

    filterResults() {
        let filteredData = from(this.props.data);
        

        if(this.textFilterFields.length > 0 && this.state.searchCriteria.length >= 3) {
            const searchCriteria = this.state.searchCriteria.toLowerCase();
            filteredData = filteredData.where(x => {
                for(const field of this.textFilterFields)
                {
                    if(x[field].toLowerCase().indexOf(searchCriteria) >= 0)
                    { return true; }
                }
                return false;
            });
        }

        const pagedData = filteredData
            .skip((this.state.currentPage-1) * this.state.pageSize)
            .take(10000)
            .toArray();

        this.setState({filteredData: filteredData.toArray(), pagedData});
    }


    UNSAFE_componentWillReceiveProps = (newProps) => {
        this.setState(newProps, this.filterResults);
    };

    onFilterChanged = (event) => {
        this.setState({searchCriteria: event.target.value }, this.filterResults);
    };

    onPageSizeChanged = (event, data) => {
        const newValue = parseInt(data.value);
        this.setState({pageSize: newValue}, this.filterResults)
    };

    onPageChanged = (event, data) => {
        const { activePage } = data;
        if (activePage !== this.state.currentPage) {
            this.setState({currentPage: activePage}, this.filterResults)
        }
    };

    render() {
        return (
            <Repeater data={this.state.pagedData} component={this.props.component} onElementInteraction={this.props.onElementInteraction}>
                <Repeater.Header>
                    <Grid  stackable columns='equal' verticalAlign='middle'>
                        {!!this.textFilterFields.length > 0 &&
                        <Grid.Row>
                            <Grid.Column>
                                <label>Search</label>
                                <br/>
                                <Input fluid value={this.state.searchCriteria} placeholder="Search..." onChange={this.onFilterChanged} />
                            </Grid.Column>
                        </Grid.Row>}
                        {/* <Grid.Row>
                            <PageSizeSelect limit={this.state.pageSize.toString()} onChangeLimit={this.onPageSizeChanged} />
                            Total count: {this.totalCount}.
                        </Grid.Row> */}
                    </Grid>
                </Repeater.Header>
                <Repeater.Footer>
                    {/* <Grid  stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                <Pagination
                                    totalPages={this.totalPages}
                                    activePage={this.state.currentPage}
                                    onPageChange={this.onPageChanged}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid> */}
                </Repeater.Footer>
            </Repeater>
        );
    }
}

FilterableRepeater.propTypes = {
    data: PropTypes.array.isRequired,
    component: PropTypes.elementType.isRequired,
    textFilterFields: PropTypes.arrayOf(PropTypes.string),
    onElementInteraction: PropTypes.func
};

export default FilterableRepeater
